import { render, staticRenderFns } from "./FilePreview.vue?vue&type=template&id=c2f1b064&scoped=true&"
import script from "./FilePreview.vue?vue&type=script&lang=js&"
export * from "./FilePreview.vue?vue&type=script&lang=js&"
import style0 from "./FilePreview.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./FilePreview.vue?vue&type=style&index=1&id=c2f1b064&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2f1b064",
  null
  
)

export default component.exports